// Centralized configuration

// API endpoints
export const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.stavbot.com/api',
  soundboardUrl: 'https://server.stavbot.com',
};

// Character configurations
export const CHARACTERS = {
  nick: {
    id: 'nick',
    name: 'Nick',
    title: 'Nick Soundboard',
    endpoint: '/getAudio/nick',
    avatar: 'https://www.carolines.com/wp-content/uploads/2022/04/Nick-Mullen1-3x2-1.jpg',
    color: '#6366f1', // Indigo
  },
  stav: {
    id: 'stav',
    name: 'Stav',
    title: 'Stav Soundboard',
    endpoint: '/getAudio/stav',
    avatar: 'https://media.distractify.com/brand-img/pdTrQJycu/0x0/stavros-1656347717876.jpg',
    color: '#10b981', // Green
  },
  adam: {
    id: 'adam',
    name: 'Adam',
    title: 'Adam Soundboard',
    endpoint: '/getAudio/adam',
    avatar: 'https://i.ticketweb.com/i/00/08/98/21/81/Original.jpg?v=1',
    color: '#f59e0b', // Amber
  },
};

// Firebase configuration
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Limits
export const LIMITS = {
  maxMessageLength: 1000,
  maxUsernameLength: 50,
  rateLimitRequests: 5,
  rateLimitWindowMs: 60000,
};
